import React from "react";
import { connect } from "react-redux";
import ListItemText, {
    Typography,
    IconButton,
    WithStyles,
    withStyles,
    ListItem,
    Grid,
    Button,
} from "material-ui";
import ErrorOutlineIcon from "material-ui-icons/ErrorOutline";
import { RouteComponentProps, RouterProps } from "react-router";
import moment from "moment";

import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import AlternatingList from "../../components/AlternatingList";
import {
    SetShowBackNavigation,
    ShowBackNavigationWithRoute,
    SetHeader,
} from "../../ducks/common";
import {
    getAccountData,
    getAccount,
    editAccountName,
    getAllAccountsData,
} from "../../ducks/account";
import { AccountDto, AccountLoan } from "../../util/DTOs/AccountDtos";
import { EditableHeader } from "../../components/EditableHeader/EditableHeader";
import { Link } from "react-router-dom";
import { formatNumber } from "util/utils";

const styles = {
    container: {
        paddingRight: 15,
        paddingLeft: 15,
        marginBottom: 60,
    },
    subheadingWeight: {
        fontWeight: "200",
    },
    centerText: {
        textAlign: "center",
    },
    rightText: {
        textAlign: "right",
    },
    flexRoot: {
        display: "flex",
        width: "100%",
    },
    flexItem: {
        flex: 1,
        whiteSpace: "nowrap",
    },
} as React.CSSProperties;

interface IAccountPageProps {
    id: number;
    isVisibleView: boolean;
}
interface IAccountPageReduxProps {
    accountData: AccountDto;
}

interface IAccountPageDispatchProps {
    setHeaderValue: (header: string) => void;
    getAccountData: (id: number) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
    saveAccountName: (
        id: number,
        accountNumber: string,
        accountName: string
    ) => void;
}

interface AccountPageState {}

type AccountPageProps = IAccountPageProps &
    IAccountPageReduxProps &
    IAccountPageDispatchProps &
    RouterProps;

type AccountPagePropsWithStyles = AccountPageProps &
    WithStyles<
        | "container"
        | "subheadingWeight"
        | "centerText"
        | "rightText"
        | "flexRoot"
        | "flexItem"
        | "flatButton"
    >;

class AccountPage extends React.Component<
    AccountPagePropsWithStyles,
    AccountPageState
> {
    componentDidMount() {
        if (!this.props.accountData) {
            this.props.getAccountData(this.props.id);
        }
        this.props.setBackButton("/");
    }

    componentWillUnmount() {
        this.props.hideBackButton();
    }

    saveAccountName = (value: string) => {
        // Save edited account name
        this.props.saveAccountName(
            this.props.accountData.id,
            this.props.accountData.accountNumber,
            value
        );
    };

    renderAccountLoans = (loans: AccountLoan[]) => {
        let elems: Array<JSX.Element> = [];
        loans.map((loan, key) => {
            elems.push(
                // <Link key={key} to={`/loan/${loan.id}`} className={`link`} style={{margin: 0, marginTop: "0.5em"}}>
                //   {loan.loanName || loan.loanNumber}
                // </Link>
                <p style={{ margin: 0, marginTop: "0.5em" }} key={key}>
                    <a
                        key={key}
                        className={`link`}
                        href="#"
                        tabIndex={!this.props.isVisibleView ? -1 : undefined}
                    >
                        {loan.loanName || loan.loanNumber}
                    </a>
                </p>
            );
        });

        return elems;
    };

    render() {
        const { classes, accountData } = this.props;
        return (
            <Grid
                container
                style={{ width: "100%", marginLeft: 0, marginRight: 0 }}
                className={`${classes.container}`}
            >
                <Grid item xs={12} style={{ paddingRight: 0, paddingLeft: 0 }}>
                    <div>
                        <EditableHeader
                            saveValue={this.saveAccountName}
                            value={accountData.accountName || "Talletustili"}
                            headerType={"h2"}
                            maxLength={50}
                            label="Muokkaa tilin nimeä"
                            isVisible={this.props.isVisibleView}
                        />
                        <p
                            className={`hypodgrey no-margin`}
                        >{`#${accountData.accountNumber}`}</p>
                    </div>

                    <div>
                        <div style={{ position: "relative" }}>
                            <h2
                                className={`hypodgrey ${classes.subheadingWeight}`}
                            >
                                Saldo
                                <span style={{ fontSize: "17px" }}>
                                    {(accountData.currentDate &&
                                        ` (${moment(
                                            accountData.currentDate
                                        ).format("D.M.")})`) ||
                                        ``}
                                </span>
                            </h2>
                            {this.props.accountData.referenceNumber &&
                                this.props.accountData.canDeposit && (
                                    <Button
                                        variant="flat"
                                        color="primary"
                                        style={{
                                            position: "absolute",
                                            right: 0,
                                            top: 0,
                                        }}
                                        tabIndex={
                                            !this.props.isVisibleView
                                                ? -1
                                                : undefined
                                        }
                                        onClick={() =>
                                            this.props.history.push(
                                                `/account/${this.props.id}/deposit`
                                            )
                                        }
                                    >
                                        Talletusohje
                                    </Button>
                                )}
                        </div>
                        <p
                            className={`primary-info no-margin ${classes.centerText}`}
                        >
                            {`${formatNumber(accountData.balance, 2)} €`}
                        </p>
                    </div>

                    <div>
                        <h2 className={`hypodgrey ${classes.subheadingWeight}`}>
                            Korko
                        </h2>
                        <p
                            className={`primary-info no-margin ${classes.centerText}`}
                        >
                            {`${formatNumber(accountData.fullInterest, 3)} %`}
                        </p>
                    </div>

                    {accountData.transactions &&
                        accountData.transactions.length > 0 && (
                            <div>
                                <h2
                                    className={`hypodgrey ${classes.subheadingWeight}`}
                                >
                                    Viimeisimmät tapahtumat
                                </h2>
                                <AlternatingList>
                                    {accountData.transactions
                                        .slice(0, 6)
                                        .map((transaction, index) => (
                                            <ListItem key={index}>
                                                <div
                                                    className={`${classes.flexRoot}`}
                                                >
                                                    <span
                                                        className="hypodgrey"
                                                        style={{
                                                            marginRight: 15,
                                                        }}
                                                    >
                                                        {moment(
                                                            transaction.transactionDate
                                                        ).format("DD.MM.YYYY")}
                                                    </span>
                                                    <span
                                                        className={`hypodgrey fade ${classes.flexItem}`}
                                                    >
                                                        {
                                                            transaction.transactionName
                                                        }
                                                    </span>
                                                    <span
                                                        className={`${
                                                            transaction.transactionAmount <
                                                            0.0
                                                                ? "payment-negative"
                                                                : "payment"
                                                        } ${classes.rightText}`}
                                                    >
                                                        {`${formatNumber(
                                                            transaction.transactionAmount,
                                                            2
                                                        )} €`}
                                                    </span>
                                                </div>
                                            </ListItem>
                                        ))}
                                </AlternatingList>
                            </div>
                        )}

                    <div>
                        <h2 className={`hypodgrey ${classes.subheadingWeight}`}>
                            Perustiedot
                        </h2>
                        <div>
                            <h3
                                className={`hypodgrey no-margin`}
                                style={{ fontSize: 16 }}
                            >
                                Omistajat:
                            </h3>
                            {accountData.owners.map((owner, i) => (
                                <h2
                                    key={i}
                                    className="hypoblue no-margin"
                                    style={{ marginLeft: 15 }}
                                >
                                    {owner}
                                </h2>
                            ))}
                        </div>
                        {accountData.accessHolders &&
                            accountData.accessHolders.length > 0 && (
                                <div>
                                    <h3
                                        className={`hypodgrey no-margin`}
                                        style={{ fontSize: 16 }}
                                    >
                                        Käyttöoikeuden haltijat:
                                    </h3>
                                    {accountData.accessHolders.map(
                                        (accessHolder, i) => (
                                            <h2
                                                key={i}
                                                className="hypoblue no-margin"
                                                style={{ marginLeft: 15 }}
                                            >
                                                {accessHolder}
                                            </h2>
                                        )
                                    )}
                                </div>
                            )}
                        {accountData.fixedTermDepositEndDate && (
                            <div>
                                <h3
                                    className={`hypodgrey no-margin`}
                                    style={{ fontSize: 16 }}
                                >
                                    Talletuksen päättymispäivä:
                                </h3>
                                <h2
                                    className="hypoblue no-margin"
                                    style={{ marginLeft: 15 }}
                                >
                                    {moment(
                                        accountData.fixedTermDepositEndDate
                                    ).format("DD.MM.YYYY")}
                                </h2>
                            </div>
                        )}
                        {/* <div>
              <h4 className={`hypogrey no-margin`}>Vastatili:</h4>
              <h2 className="hypoblue no-margin" style={{ marginLeft: 15 }}>{accountData.contraAccount.accountName}</h2>
              <p className={`hypolgrey no-margin`} style={{ marginLeft: 15 }}>{`#${accountData.contraAccount.accountNumber}`}</p>
            </div> */}
                    </div>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (
    state: ReduxState,
    props: AccountPageProps
): IAccountPageReduxProps => {
    const accountData = getAccountData(state, props.id);
    return {
        accountData: accountData,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IAccountPageDispatchProps => {
    return {
        setHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        getAccountData: async (id: number) => {
            await dispatch(getAccount(id));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        saveAccountName: (
            id: number,
            accountNumber: string,
            accountName: string
        ) => {
            dispatch(editAccountName({ id, accountNumber, accountName }));
        },
    };
};

export default connect<
    IAccountPageReduxProps,
    IAccountPageDispatchProps,
    IAccountPageProps
>(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(AccountPage));



// WEBPACK FOOTER //
// ./src/views/account/AccountPage.tsx